<section class="operations-page">
    <app-operations-back-link
            routerLink="/operations/provider-events"
            [queryParams]="backLinkQueryParams"
            label="← Back to provider events"
    ></app-operations-back-link>

    <div class="operations-page__card" *ngIf="loading">
        <p class="operations-page__loading">Loading provider event…</p>
    </div>

    <div *ngIf="!loading && !event" class="operations-page__card">
        <p class="operations-page__empty">Provider event not found.</p>
    </div>

    <ng-container *ngIf="!loading && event as evt">
        <header class="operations-page__header">
            <div>
                <h2 class="operations-page__title">{{ providerEventView.getProviderLabel(evt.provider_id) }}</h2>
                <p class="operations-page__lead">{{ evt.provider_event_id }}</p>
            </div>
            <app-provider-event-status-badge [status]="evt.processing_status"></app-provider-event-status-badge>
        </header>

        <div class="operations-detail-grid">
            <app-metadata-panel
                    title="Provider metadata"
                    [entries]="providerEventView.buildMetadataEntries(evt)"
            ></app-metadata-panel>

            <app-metadata-panel
                    *ngIf="diagnosticsEntries.length"
                    title="Processing diagnostics"
                    [entries]="diagnosticsEntries"
            ></app-metadata-panel>

            <app-metadata-panel
                    title="Normalized event information"
                    [entries]="providerEventView.buildNormalizedFieldEntries(evt)"
            ></app-metadata-panel>
        </div>

        <section class="operations-page__card" *ngIf="evt.matched_transaction_id">
            <h3 class="operations-page__title">Related vehicle transaction</h3>
            <div class="operations-links">
                <div class="operations-links__item">
                    <span>{{ evt.matched_transaction_id }}</span>
                    <a class="operations-table__link"
                       [routerLink]="['/operations/transactions', evt.matched_transaction_id]">
                        View transaction
                    </a>
                </div>
            </div>
        </section>

        <section class="operations-page__card">
            <h3 class="operations-page__title">Processing timeline</h3>
            <app-activity-timeline [activities]="timelineActivities"></app-activity-timeline>
        </section>
    </ng-container>
</section>
